/* eslint-disable */

if (typeof deconcept == "undefined") {
    var deconcept = new Object
}
if (typeof deconcept.util == "undefined") {
    deconcept.util = new Object
}
if (typeof deconcept.SWFObjectUtil == "undefined") {
    deconcept.SWFObjectUtil = new Object
}
deconcept.SWFObject = function(_1, id, w, h, _5, c, _7, _8, _9, _a) {
    if (!document.getElementById) {
        return
    }
    this.DETECT_KEY = _a ? _a : "detectflash";
    this.skipDetect = deconcept.util.getRequestParameter(this.DETECT_KEY);
    this.params = new Object;
    this.variables = new Object;
    this.attributes = new Array;
    if (_1) {
        this.setAttribute("swf", _1)
    }
    if (id) {
        this.setAttribute("id", id)
    }
    if (w) {
        this.setAttribute("width", w)
    }
    if (h) {
        this.setAttribute("height", h)
    }
    if (_5) {
        this.setAttribute("version", new deconcept.PlayerVersion(_5.toString().split(".")))
    }
    this.installedVer = deconcept.SWFObjectUtil.getPlayerVersion();
    if (!window.opera && document.all && this.installedVer.major > 7) {
        deconcept.SWFObject.doPrepUnload = true
    }
    if (c) {
        this.addParam("bgcolor", c)
    }
    var q = _7 ? _7 : "high";
    this.addParam("quality", q);
    this.setAttribute("useExpressInstall", false);
    this.setAttribute("doExpressInstall", false);
    var _c = _8 ? _8 : window.location;
    this.setAttribute("xiRedirectUrl", _c);
    this.setAttribute("redirectUrl", "");
    if (_9) {
        this.setAttribute("redirectUrl", _9)
    }
};
deconcept.SWFObject.prototype = {
    useExpressInstall: function(_d) {
        this.xiSWFPath = !_d ? "expressinstall.swf" : _d;
        this.setAttribute("useExpressInstall", true)
    },
    setAttribute: function(_e, _f) {
        this.attributes[_e] = _f
    },
    getAttribute: function(_10) {
        return this.attributes[_10]
    },
    addParam: function(_11, _12) {
        this.params[_11] = _12
    },
    getParams: function() {
        return this.params
    },
    addVariable: function(_13, _14) {
        this.variables[_13] = _14
    },
    getVariable: function(_15) {
        return this.variables[_15]
    },
    getVariables: function() {
        return this.variables
    },
    getVariablePairs: function() {
        var _16 = new Array;
        var key;
        var _18 = this.getVariables();
        for (key in _18) {
            _16[_16.length] = key + "=" + _18[key]
        }
        return _16
    },
    getSWFHTML: function() {
        var _19 = "";
        if (navigator.plugins && navigator.mimeTypes && navigator.mimeTypes.length) {
            if (this.getAttribute("doExpressInstall")) {
                this.addVariable("MMplayerType", "PlugIn");
                this.setAttribute("swf", this.xiSWFPath)
            }
            _19 = '<embed type="application/x-shockwave-flash" src="' + this.getAttribute("swf") + '" width="' + this.getAttribute("width") + '" height="' + this.getAttribute("height") + '" style="' + this.getAttribute("style") + '"';
            _19 += ' id="' + this.getAttribute("id") + '" name="' + this.getAttribute("id") + '" ';
            var _1a = this.getParams();
            for (var key in _1a) {
                _19 += [key] + '="' + _1a[key] + '" '
            }
            var _1c = this.getVariablePairs().join("&");
            if (_1c.length > 0) {
                _19 += 'flashvars="' + _1c + '"'
            }
            _19 += "/>"
        } else {
            if (this.getAttribute("doExpressInstall")) {
                this.addVariable("MMplayerType", "ActiveX");
                this.setAttribute("swf", this.xiSWFPath)
            }
            _19 = '<object id="' + this.getAttribute("id") + '" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="' + this.getAttribute("width") + '" height="' + this.getAttribute("height") + '" style="' + this.getAttribute("style") + '">';
            _19 += '<param name="movie" value="' + this.getAttribute("swf") + '" />';
            var _1d = this.getParams();
            for (var key in _1d) {
                _19 += '<param name="' + key + '" value="' + _1d[key] + '" />'
            }
            var _1f = this.getVariablePairs().join("&");
            if (_1f.length > 0) {
                _19 += '<param name="flashvars" value="' + _1f + '" />'
            }
            _19 += "</object>"
        }
        return _19
    },
    write: function(_20) {
        if (this.getAttribute("useExpressInstall")) {
            var _21 = new deconcept.PlayerVersion([6, 0, 65]);
            if (this.installedVer.versionIsValid(_21) && !this.installedVer.versionIsValid(this.getAttribute("version"))) {
                this.setAttribute("doExpressInstall", true);
                this.addVariable("MMredirectURL", escape(this.getAttribute("xiRedirectUrl")));
                document.title = document.title.slice(0, 47) + " - Flash Player Installation";
                this.addVariable("MMdoctitle", document.title)
            }
        }
        if (this.skipDetect || this.getAttribute("doExpressInstall") || this.installedVer.versionIsValid(this.getAttribute("version"))) {
            var n = typeof _20 == "string" ? document.getElementById(_20) : _20;
            n.innerHTML = this.getSWFHTML();
            return true
        } else {
            if (this.getAttribute("redirectUrl") != "") {
                document.location.replace(this.getAttribute("redirectUrl"))
            }
        }
        return false
    }
};
deconcept.SWFObjectUtil.getPlayerVersion = function() {
    var _23 = new deconcept.PlayerVersion([0, 0, 0]);
    if (navigator.plugins && navigator.mimeTypes.length) {
        var x = navigator.plugins["Shockwave Flash"];
        if (x && x.description) {
            _23 = new deconcept.PlayerVersion(x.description.replace(/([a-zA-Z]|\s)+/, "").replace(/(\s+r|\s+b[0-9]+)/, ".").split("."))
        }
    } else {
        if (navigator.userAgent && navigator.userAgent.indexOf("Windows CE") >= 0) {
            var axo = 1;
            var _26 = 3;
            while (axo) {
                try {
                    _26++;
                    axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash." + _26);
                    _23 = new deconcept.PlayerVersion([_26, 0, 0])
                } catch (e) {
                    axo = null
                }
            }
        } else {
            try {
                var axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.7")
            } catch (e) {
                try {
                    var axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.6");
                    _23 = new deconcept.PlayerVersion([6, 0, 21]);
                    axo.AllowScriptAccess = "always"
                } catch (e) {
                    if (_23.major == 6) {
                        return _23
                    }
                }
                try {
                    axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash")
                } catch (e) {}
            }
            if (axo != null) {
                _23 = new deconcept.PlayerVersion(axo.GetVariable("$version").split(" ")[1].split(","))
            }
        }
    }
    return _23
};
deconcept.PlayerVersion = function(_29) {
    this.major = _29[0] != null ? parseInt(_29[0]) : 0;
    this.minor = _29[1] != null ? parseInt(_29[1]) : 0;
    this.rev = _29[2] != null ? parseInt(_29[2]) : 0
};
deconcept.PlayerVersion.prototype.versionIsValid = function(fv) {
    if (this.major < fv.major) {
        return false
    }
    if (this.major > fv.major) {
        return true
    }
    if (this.minor < fv.minor) {
        return false
    }
    if (this.minor > fv.minor) {
        return true
    }
    if (this.rev < fv.rev) {
        return false
    }
    return true
};
deconcept.util = {
    getRequestParameter: function(_2b) {
        var q = document.location.search || document.location.hash;
        if (_2b == null) {
            return q
        }
        if (q) {
            var _2d = q.substring(1).split("&");
            for (var i = 0; i < _2d.length; i++) {
                if (_2d[i].substring(0, _2d[i].indexOf("=")) == _2b) {
                    return _2d[i].substring(_2d[i].indexOf("=") + 1)
                }
            }
        }
        return ""
    }
};
deconcept.SWFObjectUtil.cleanupSWFs = function() {
    var _2f = document.getElementsByTagName("OBJECT");
    for (var i = _2f.length - 1; i >= 0; i--) {
        _2f[i].style.display = "none";
        for (var x in _2f[i]) {
            if (typeof _2f[i][x] == "function") {
                _2f[i][x] = function() {}
            }
        }
    }
};
if (deconcept.SWFObject.doPrepUnload) {
    if (!deconcept.unloadSet) {
        deconcept.SWFObjectUtil.prepUnload = function() {
            __flash_unloadHandler = function() {};
            __flash_savedUnloadHandler = function() {};
            window.attachEvent("onunload", deconcept.SWFObjectUtil.cleanupSWFs)
        };
        window.attachEvent("onbeforeunload", deconcept.SWFObjectUtil.prepUnload);
        deconcept.unloadSet = true
    }
}
if (!document.getElementById && document.all) {
    document.getElementById = function(id) {
        return document.all[id]
    }
}
var getQueryParamValue = deconcept.util.getRequestParameter;
var FlashObject = deconcept.SWFObject;
var SWFObject = deconcept.SWFObject;
var swfobject = function() {
    var b = "undefined",
        Q = "object",
        n = "Shockwave Flash",
        p = "ShockwaveFlash.ShockwaveFlash",
        P = "application/x-shockwave-flash",
        m = "SWFObjectExprInst",
        j = window,
        K = document,
        T = navigator,
        o = [],
        N = [],
        i = [],
        d = [],
        J, Z = null,
        M = null,
        l = null,
        e = false,
        A = false;
    var h = function() {
        var v = typeof K.getElementById != b && typeof K.getElementsByTagName != b && typeof K.createElement != b,
            AC = [0, 0, 0],
            x = null;
        if (typeof T.plugins != b && typeof T.plugins[n] == Q) {
            x = T.plugins[n].description;
            if (x && !(typeof T.mimeTypes != b && T.mimeTypes[P] && !T.mimeTypes[P].enabledPlugin)) {
                x = x.replace(/^.*\s+(\S+\s+\S+$)/, "$1");
                AC[0] = parseInt(x.replace(/^(.*)\..*$/, "$1"), 10);
                AC[1] = parseInt(x.replace(/^.*\.(.*)\s.*$/, "$1"), 10);
                AC[2] = /r/.test(x) ? parseInt(x.replace(/^.*r(.*)$/, "$1"), 10) : 0
            }
        } else {
            if (typeof j.ActiveXObject != b) {
                var y = null,
                    AB = false;
                try {
                    y = new ActiveXObject(p + ".7")
                } catch (t) {
                    try {
                        y = new ActiveXObject(p + ".6");
                        AC = [6, 0, 21];
                        y.AllowScriptAccess = "always"
                    } catch (t) {
                        if (AC[0] == 6) {
                            AB = true
                        }
                    }
                    if (!AB) {
                        try {
                            y = new ActiveXObject(p)
                        } catch (t) {}
                    }
                }
                if (!AB && y) {
                    try {
                        x = y.GetVariable("$version");
                        if (x) {
                            x = x.split(" ")[1].split(",");
                            AC = [parseInt(x[0], 10), parseInt(x[1], 10), parseInt(x[2], 10)]
                        }
                    } catch (t) {}
                }
            }
        }
        var AD = T.userAgent.toLowerCase(),
            r = T.platform.toLowerCase(),
            AA = /webkit/.test(AD) ? parseFloat(AD.replace(/^.*webkit\/(\d+(\.\d+)?).*$/, "$1")) : false,
            q = false,
            z = r ? /win/.test(r) : /win/.test(AD),
            w = r ? /mac/.test(r) : /mac/.test(AD);
        return {
            w3cdom: v,
            pv: AC,
            webkit: AA,
            ie: q,
            win: z,
            mac: w
        }
    }();
    var L = function() {
        if (!h.w3cdom) {
            return
        }
        f(H);
        if (h.ie && h.win) {
            try {
                K.write("<script id=__ie_ondomload defer=true src=//:></script>");
                J = C("__ie_ondomload");
                if (J) {
                    I(J, "onreadystatechange", S)
                }
            } catch (q) {}
        }
        if (h.webkit && typeof K.readyState != b) {
            Z = setInterval(function() {
                if (/loaded|complete/.test(K.readyState)) {
                    E()
                }
            }, 10)
        }
        if (typeof K.addEventListener != b) {
            K.addEventListener("DOMContentLoaded", E, null)
        }
        R(E)
    }();

    function S() {
        if (J.readyState == "complete") {
            J.parentNode.removeChild(J);
            E()
        }
    }

    function E() {
        if (e) {
            return
        }
        if (h.ie && h.win) {
            var v = a("span");
            try {
                var u = K.getElementsByTagName("body")[0].appendChild(v);
                u.parentNode.removeChild(u)
            } catch (w) {
                return
            }
        }
        e = true;
        if (Z) {
            clearInterval(Z);
            Z = null
        }
        var q = o.length;
        for (var r = 0; r < q; r++) {
            o[r]()
        }
    }

    function f(q) {
        if (e) {
            q()
        } else {
            o[o.length] = q
        }
    }

    function R(r) {
        if (typeof j.addEventListener != b) {
            j.addEventListener("load", r, false)
        } else {
            if (typeof K.addEventListener != b) {
                K.addEventListener("load", r, false)
            } else {
                if (typeof j.attachEvent != b) {
                    I(j, "onload", r)
                } else {
                    if (typeof j.onload == "function") {
                        var q = j.onload;
                        j.onload = function() {
                            q();
                            r()
                        }
                    } else {
                        j.onload = r
                    }
                }
            }
        }
    }

    function H() {
        var t = N.length;
        for (var q = 0; q < t; q++) {
            var u = N[q].id;
            if (h.pv[0] > 0) {
                var r = C(u);
                if (r) {
                    N[q].width = r.getAttribute("width") ? r.getAttribute("width") : "0";
                    N[q].height = r.getAttribute("height") ? r.getAttribute("height") : "0";
                    if (c(N[q].swfVersion)) {
                        if (h.webkit && h.webkit < 312) {
                            Y(r)
                        }
                        W(u, true)
                    } else {
                        if (N[q].expressInstall && !A && c("6.0.65") && (h.win || h.mac)) {
                            k(N[q])
                        } else {
                            O(r)
                        }
                    }
                }
            } else {
                W(u, true)
            }
        }
    }

    function Y(t) {
        var q = t.getElementsByTagName(Q)[0];
        if (q) {
            var w = a("embed"),
                y = q.attributes;
            if (y) {
                var v = y.length;
                for (var u = 0; u < v; u++) {
                    if (y[u].nodeName == "DATA") {
                        w.setAttribute("src", y[u].nodeValue)
                    } else {
                        w.setAttribute(y[u].nodeName, y[u].nodeValue)
                    }
                }
            }
            var x = q.childNodes;
            if (x) {
                var z = x.length;
                for (var r = 0; r < z; r++) {
                    if (x[r].nodeType == 1 && x[r].nodeName == "PARAM") {
                        w.setAttribute(x[r].getAttribute("name"), x[r].getAttribute("value"))
                    }
                }
            }
            t.parentNode.replaceChild(w, t)
        }
    }

    function k(w) {
        A = true;
        var u = C(w.id);
        if (u) {
            if (w.altContentId) {
                var y = C(w.altContentId);
                if (y) {
                    M = y;
                    l = w.altContentId
                }
            } else {
                M = G(u)
            }
            if (!/%$/.test(w.width) && parseInt(w.width, 10) < 310) {
                w.width = "310"
            }
            if (!/%$/.test(w.height) && parseInt(w.height, 10) < 137) {
                w.height = "137"
            }
            K.title = K.title.slice(0, 47) + " - Flash Player Installation";
            var z = h.ie && h.win ? "ActiveX" : "PlugIn",
                q = K.title,
                r = "MMredirectURL=" + j.location + "&MMplayerType=" + z + "&MMdoctitle=" + q,
                x = w.id;
            if (h.ie && h.win && u.readyState != 4) {
                var t = a("div");
                x += "SWFObjectNew";
                t.setAttribute("id", x);
                u.parentNode.insertBefore(t, u);
                u.style.display = "none";
                var v = function() {
                    u.parentNode.removeChild(u)
                };
                I(j, "onload", v)
            }
            U({
                data: w.expressInstall,
                id: m,
                width: w.width,
                height: w.height
            }, {
                flashvars: r
            }, x)
        }
    }

    function O(t) {
        if (h.ie && h.win && t.readyState != 4) {
            var r = a("div");
            t.parentNode.insertBefore(r, t);
            r.parentNode.replaceChild(G(t), r);
            t.style.display = "none";
            var q = function() {
                t.parentNode.removeChild(t)
            };
            I(j, "onload", q)
        } else {
            t.parentNode.replaceChild(G(t), t)
        }
    }

    function G(v) {
        var u = a("div");
        if (h.win && h.ie) {
            u.innerHTML = v.innerHTML
        } else {
            var r = v.getElementsByTagName(Q)[0];
            if (r) {
                var w = r.childNodes;
                if (w) {
                    var q = w.length;
                    for (var t = 0; t < q; t++) {
                        if (!(w[t].nodeType == 1 && w[t].nodeName == "PARAM") && !(w[t].nodeType == 8)) {
                            u.appendChild(w[t].cloneNode(true))
                        }
                    }
                }
            }
        }
        return u
    }

    function U(AG, AE, t) {
        var q, v = C(t);
        if (v) {
            if (typeof AG.id == b) {
                AG.id = t
            }
            if (h.ie && h.win) {
                var AF = "";
                for (var AB in AG) {
                    if (AG[AB] != Object.prototype[AB]) {
                        if (AB.toLowerCase() == "data") {
                            AE.movie = AG[AB]
                        } else {
                            if (AB.toLowerCase() == "styleclass") {
                                AF += ' class="' + AG[AB] + '"'
                            } else {
                                if (AB.toLowerCase() != "classid") {
                                    AF += " " + AB + '="' + AG[AB] + '"'
                                }
                            }
                        }
                    }
                }
                var AD = "";
                for (var AA in AE) {
                    if (AE[AA] != Object.prototype[AA]) {
                        AD += '<param name="' + AA + '" value="' + AE[AA] + '" />'
                    }
                }
                v.outerHTML = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"' + AF + ">" + AD + "</object>";
                i[i.length] = AG.id;
                q = C(AG.id)
            } else {
                if (h.webkit && h.webkit < 312) {
                    var AC = a("embed");
                    AC.setAttribute("type", P);
                    for (var z in AG) {
                        if (AG[z] != Object.prototype[z]) {
                            if (z.toLowerCase() == "data") {
                                AC.setAttribute("src", AG[z])
                            } else {
                                if (z.toLowerCase() == "styleclass") {
                                    AC.setAttribute("class", AG[z])
                                } else {
                                    if (z.toLowerCase() != "classid") {
                                        AC.setAttribute(z, AG[z])
                                    }
                                }
                            }
                        }
                    }
                    for (var y in AE) {
                        if (AE[y] != Object.prototype[y]) {
                            if (y.toLowerCase() != "movie") {
                                AC.setAttribute(y, AE[y])
                            }
                        }
                    }
                    v.parentNode.replaceChild(AC, v);
                    q = AC
                } else {
                    var u = a(Q);
                    u.setAttribute("type", P);
                    for (var x in AG) {
                        if (AG[x] != Object.prototype[x]) {
                            if (x.toLowerCase() == "styleclass") {
                                u.setAttribute("class", AG[x])
                            } else {
                                if (x.toLowerCase() != "classid") {
                                    u.setAttribute(x, AG[x])
                                }
                            }
                        }
                    }
                    for (var w in AE) {
                        if (AE[w] != Object.prototype[w] && w.toLowerCase() != "movie") {
                            F(u, w, AE[w])
                        }
                    }
                    v.parentNode.replaceChild(u, v);
                    q = u
                }
            }
        }
        return q
    }

    function F(t, q, r) {
        var u = a("param");
        u.setAttribute("name", q);
        u.setAttribute("value", r);
        t.appendChild(u)
    }

    function X(r) {
        var q = C(r);
        if (q && (q.nodeName == "OBJECT" || q.nodeName == "EMBED")) {
            if (h.ie && h.win) {
                if (q.readyState == 4) {
                    B(r)
                } else {
                    j.attachEvent("onload", function() {
                        B(r)
                    })
                }
            } else {
                q.parentNode.removeChild(q)
            }
        }
    }

    function B(t) {
        var r = C(t);
        if (r) {
            for (var q in r) {
                if (typeof r[q] == "function") {
                    r[q] = null
                }
            }
            r.parentNode.removeChild(r)
        }
    }

    function C(t) {
        var q = null;
        try {
            q = K.getElementById(t)
        } catch (r) {}
        return q
    }

    function a(q) {
        return K.createElement(q)
    }

    function I(t, q, r) {
        t.attachEvent(q, r);
        d[d.length] = [t, q, r]
    }

    function c(t) {
        var r = h.pv,
            q = t.split(".");
        q[0] = parseInt(q[0], 10);
        q[1] = parseInt(q[1], 10) || 0;
        q[2] = parseInt(q[2], 10) || 0;
        return r[0] > q[0] || r[0] == q[0] && r[1] > q[1] || r[0] == q[0] && r[1] == q[1] && r[2] >= q[2] ? true : false
    }

    function V(v, r) {
        if (h.ie && h.mac) {
            return
        }
        var u = K.getElementsByTagName("head")[0],
            t = a("style");
        t.setAttribute("type", "text/css");
        t.setAttribute("media", "screen");
        if (!(h.ie && h.win) && typeof K.createTextNode != b) {
            t.appendChild(K.createTextNode(v + " {" + r + "}"))
        }
        u.appendChild(t);
        if (h.ie && h.win && typeof K.styleSheets != b && K.styleSheets.length > 0) {
            var q = K.styleSheets[K.styleSheets.length - 1];
            if (typeof q.addRule == Q) {
                q.addRule(v, r)
            }
        }
    }

    function W(t, q) {
        var r = q ? "visible" : "hidden";
        if (e && C(t)) {
            C(t).style.visibility = r
        } else {
            V("#" + t, "visibility:" + r)
        }
    }

    function g(s) {
        var r = /[\\\"<>\.;]/;
        var q = r.exec(s) != null;
        return q ? encodeURIComponent(s) : s
    }
    var D = function() {
        if (h.ie && h.win) {
            window.attachEvent("onunload", function() {
                var w = d.length;
                for (var v = 0; v < w; v++) {
                    d[v][0].detachEvent(d[v][1], d[v][2])
                }
                var t = i.length;
                for (var u = 0; u < t; u++) {
                    X(i[u])
                }
                for (var r in h) {
                    h[r] = null
                }
                h = null;
                for (var q in swfobject) {
                    swfobject[q] = null
                }
                swfobject = null
            })
        }
    }();
    return {
        registerObject: function(u, q, t) {
            if (!h.w3cdom || !u || !q) {
                return
            }
            var r = {};
            r.id = u;
            r.swfVersion = q;
            r.expressInstall = t ? t : false;
            N[N.length] = r;
            W(u, false)
        },
        getObjectById: function(v) {
            var q = null;
            if (h.w3cdom) {
                var t = C(v);
                if (t) {
                    var u = t.getElementsByTagName(Q)[0];
                    if (!u || u && typeof t.SetVariable != b) {
                        q = t
                    } else {
                        if (typeof u.SetVariable != b) {
                            q = u
                        }
                    }
                }
            }
            return q
        },
        embedSWF: function(x, AE, AB, AD, q, w, r, z, AC) {
            if (!h.w3cdom || !x || !AE || !AB || !AD || !q) {
                return
            }
            AB += "";
            AD += "";
            if (c(q)) {
                W(AE, false);
                var AA = {};
                if (AC && typeof AC === Q) {
                    for (var v in AC) {
                        if (AC[v] != Object.prototype[v]) {
                            AA[v] = AC[v]
                        }
                    }
                }
                AA.data = x;
                AA.width = AB;
                AA.height = AD;
                var y = {};
                if (z && typeof z === Q) {
                    for (var u in z) {
                        if (z[u] != Object.prototype[u]) {
                            y[u] = z[u]
                        }
                    }
                }
                if (r && typeof r === Q) {
                    for (var t in r) {
                        if (r[t] != Object.prototype[t]) {
                            if (typeof y.flashvars != b) {
                                y.flashvars += "&" + t + "=" + r[t]
                            } else {
                                y.flashvars = t + "=" + r[t]
                            }
                        }
                    }
                }
                f(function() {
                    U(AA, y, AE);
                    if (AA.id == AE) {
                        W(AE, true)
                    }
                })
            } else {
                if (w && !A && c("6.0.65") && (h.win || h.mac)) {
                    A = true;
                    W(AE, false);
                    f(function() {
                        var AF = {};
                        AF.id = AF.altContentId = AE;
                        AF.width = AB;
                        AF.height = AD;
                        AF.expressInstall = w;
                        k(AF)
                    })
                }
            }
        },
        getFlashPlayerVersion: function() {
            return {
                major: h.pv[0],
                minor: h.pv[1],
                release: h.pv[2]
            }
        },
        hasFlashPlayerVersion: c,
        createSWF: function(t, r, q) {
            if (h.w3cdom) {
                return U(t, r, q)
            } else {
                return undefined
            }
        },
        removeSWF: function(q) {
            if (h.w3cdom) {
                X(q)
            }
        },
        createCSS: function(r, q) {
            if (h.w3cdom) {
                V(r, q)
            }
        },
        addDomLoadEvent: f,
        addLoadEvent: R,
        getQueryParamValue: function(v) {
            var u = K.location.search || K.location.hash;
            if (v == null) {
                return g(u)
            }
            if (u) {
                var t = u.substring(1).split("&");
                for (var r = 0; r < t.length; r++) {
                    if (t[r].substring(0, t[r].indexOf("=")) == v) {
                        return g(t[r].substring(t[r].indexOf("=") + 1))
                    }
                }
            }
            return ""
        },
        expressInstallCallback: function() {
            if (A && M) {
                var q = C(m);
                if (q) {
                    q.parentNode.replaceChild(M, q);
                    if (l) {
                        W(l, true);
                        if (h.ie && h.win) {
                            M.style.display = "block"
                        }
                    }
                    M = null;
                    l = null;
                    A = false
                }
            }
        }
    }
}();
var vpStreaming = vpStreaming || {};
vpStreaming.player = function(elementId, options) {
    var self = this;
    var element, audioCtr, titleCtr, playCtr, stopCtr, loadingCtr, engPlay, espPlay;
    var playMethods = {
        FLASH: "FLASH",
        ASF: "ASF",
        HTML5: "HTML5",
        LINK: "LINK"
    };
    var defaults = {
        streamUrl: "https://admin.voicepad.com/listing/",
        swfPath: "/vpPlayer/swf/",
        streamKey: "",
        streamParams: "",
        engPlayText: "English",
        espPlayText: "Español",
        stopText: "Stop",
        loadingText: "Loading...",
        titleText: "",
        hideEng: false,
        hideEsp: false,
        additionalInfoOnly: false,
        onPlaybackInitiated: function() {},
        onPlaybackEnded: function() {},
        onStop: function() {}
    };
    var html5Formats = [{
        ext: ".m4a",
        mimeType: "audio/mp4"
    }, {
        ext: ".wav",
        mimeType: "audio/wav"
    }, {
        ext: ".ogg",
        mimeType: "audio/ogg"
    }];
    var playStateMgr = {
        setToLoading: function() {
            playCtr.style.display = "none";
            stopCtr.style.display = "none";
            loadingCtr.style.display = ""
        },
        setToStop: function() {
            playCtr.style.display = "none";
            loadingCtr.style.display = "none";
            stopCtr.style.display = ""
        },
        setToPlay: function() {
            stopCtr.style.display = "none";
            loadingCtr.style.display = "none";
            playCtr.style.display = "";
            audioCtr.innerHTML = ""
        }
    };
    var supportsHTML5Audio = function() {
        var a = document.createElement("audio");
        if (a.canPlayType) {
            return !!a.canPlayType("audio/ogg; codecs=vorbis").replace(/^no$/, "") || !!a.canPlayType('audio/mp4; codecs="mp4a.40.2"').replace(/^no$/, "") || !!a.canPlayType('audio/wav; codecs="1"').replace(/^no$/, "") || !!a.canPlayType("audio/wave; codecs=1").replace(/^no$/, "") || !!a.canPlayType("audio/wav; codecs=1").replace(/^no$/, "") || !!a.canPlayType("audio/x-wav; codecs=1").replace(/^no$/, "")
        }
        return false
    };
    var supportsFLASH = function() {
        var flashVersion = swfobject.getFlashPlayerVersion();
        return flashVersion.major >= 9
    };
    var getPlayMethod = function() {
        if (supportsHTML5Audio()) return playMethods.HTML5;
        if (supportsFLASH()) return playMethods.FLASH;
        if (window.navigator.userAgent.match(/MSIE /)) {
            if (window.navigator.userAgent.match(/Windows Phone OS (7.[5-9]|[8-9]|[1-9][0-9])/)) {
                return playMethods.HTML5
            } else if (window.navigator.userAgent.match(/Windows Phone OS/)) {
                return playMethods.LINK
            }
            return playMethods.ASF
        }
        return playMethods.LINK
    };
    var buildPlayer = function() {
        element = document.getElementById(elementId);
        for (var prop in defaults) {
            if (!options.hasOwnProperty(prop)) {
                options[prop] = defaults[prop]
            }
        }
        element.setAttribute("class", "vp-player");
        audioCtr = document.createElement("div");
        audioCtr.setAttribute("id", elementId + "_audioCtr");
        audioCtr.setAttribute("class", "audio-ctr");
        audioCtr.setAttribute("style", "width: 1px; height: 1px; overflow: hidden; position: absolute; top: -9999px; left: -9999px;");
        element.parentNode.insertBefore(audioCtr, element);
        var template = "<div class='accessibility-labels'>\r\n                            <label id='{{elementId}}_lblPlayer'>Audio Description of Property</label>\r\n                            <label id='{{elementId}}_lblEngBtn'>Play English Audio</label>\r\n                            <label id='{{elementId}}_lblEspBtn'>Play Spanish Audio</label>\r\n                            <label id='{{elementId}}_lblStopBtn'>Stop Audio Description</label>\r\n                       </div>\r\n                       <div class='vp-icon-volume-up'></div> \r\n                        <div id='{{elementId}}_titleCtr' class='title-ctr' style='display: none;' aria-labelledby='{{elementId}}_lblPlayer'>{{titleText}}</div> \r\n                        <div id='{{elementId}}_playCtr'> \r\n                            <div id='{{elementId}}_engPlay' class='eng-play' role='button' tabindex='0' aria-labelledby='{{elementId}}_lblEngBtn'>{{engPlayText}} \r\n                                <div class='vp-icon-play'></div> \r\n                            </div> \r\n                            <div id='{{elementId}}_espPlay' class='esp-play' role='button' tabindex='0' aria-labelledby='{{elementId}}_lblEspBtn'>{{espPlayText}} \r\n                                <div class='vp-icon-play'></div> \r\n                            </div> \r\n                        </div> \r\n                        <div id='{{elementId}}_stopCtr' class='stop-ctr' style='display: none;' role='button' tabindex='0' aria-labelledby='{{elementId}}_lblStopBtn'>{{stopText}}  <span class='vp-icon-stop'></span></div> \r\n                        <div id='{{elementId}}_loadingCtr' class='loading-ctr' style='display: none;'>{{loadingText}}</div>";
        template = template.replace(/{{elementId}}/g, elementId);
        template = template.replace(/{{titleText}}/g, options.titleText);
        template = template.replace(/{{engPlayText}}/g, options.engPlayText);
        template = template.replace(/{{espPlayText}}/g, options.espPlayText);
        template = template.replace(/{{loadingText}}/g, options.loadingText);
        template = template.replace(/{{stopText}}/g, options.stopText);
        element.innerHTML = template;
        playCtr = document.getElementById(elementId + "_playCtr");
        engPlay = document.getElementById(elementId + "_engPlay");
        espPlay = document.getElementById(elementId + "_espPlay");
        stopCtr = document.getElementById(elementId + "_stopCtr");
        loadingCtr = document.getElementById(elementId + "_loadingCtr");
        switch (getPlayMethod()) {
            case playMethods.HTML5:
                attachHTML5Handlers();
                break;
            case playMethods.ASF:
                attachASFHandlers();
                break;
            case playMethods.FLASH:
                attachFLASHHandlers();
                break;
            default:
                attachLINKHandlers();
                break
        }
    };
    var attachHTML5Handlers = function() {
        var audioElement;
        engPlay.onclick = function() {
            play("E")
        };
        engPlay.onkeydown = function(e) {
            onReturnOrSpace(e, function() {
                play("E")
            })
        };
        espPlay.onclick = function() {
            play("S")
        };
        espPlay.onkeydown = function(e) {
            onReturnOrSpace(e, function() {
                play("S")
            })
        };
        stopCtr.onclick = function() {
            stop()
        };
        stopCtr.onkeydown = function(e) {
            onReturnOrSpace(e, stop())
        };

        function stop() {
            audioElement.pause();
            audioCtr.innerHTML = "";
            playStateMgr.setToPlay();
            options.onStop()
        }

        function play(languageCode) {
            var audioStr = "";
            playStateMgr.setToLoading();
            options.onPlaybackInitiated();
            audioStr += "<audio id='vpPlayer_" + element.id + "' autobuffer='autobuffer'>";
            for (var i = 0; i < html5Formats.length; i++) {
                audioStr += "<source src='" + buildStreamUrl(languageCode, html5Formats[i].ext) + "' type='" + html5Formats[i].mimeType + "' />"
            }
            audioStr += "</audio>";
            audioCtr.innerHTML = audioStr;
            audioElement = audioCtr.firstChild;
            audioElement.addEventListener("ended", function() {
                playStateMgr.setToPlay();
                options.onPlaybackEnded()
            }, true);
            audioElement.addEventListener("waiting", function() {
                playStateMgr.setToLoading()
            }, true);
            audioElement.addEventListener("canplay", function() {
                playStateMgr.setToStop()
            }, true);
            audioElement.play()
        }

        function onReturnOrSpace(e, func) {
            var code = e.which;
            if (code === 13 || code === 32) {
                func()
            }
        }
    };
    var attachFLASHHandlers = function() {
        var swfElement;
        engPlay.onclick = function() {
            play("E")
        };
        espPlay.onclick = function() {
            play("S")
        };
        stopCtr.onclick = function() {
            audioCtr.innerHTML = "";
            playStateMgr.setToPlay();
            options.onStop()
        };

        function play(languageCode) {
            playStateMgr.setToLoading();
            options.onPlaybackInitiated();
            swfElement = document.createElement("div");
            swfElement.setAttribute("id", element.id + "_swfElement");
            audioCtr.appendChild(swfElement);
            swfobject.embedSWF(options.swfPath + "playSound.swf", swfElement.id, "1", "1", "9.0.0", false, {
                playerId: elementId,
                audioFile: buildStreamUrl(languageCode, ".m4a")
            }, {
                quality: "high",
                bgcolor: "#ffffff",
                play: "true",
                loop: "true",
                wmode: "window",
                scale: "showall",
                allowScriptAccess: "always"
            }, {
                id: "playSound"
            })
        }
    };
    var attachASFHandlers = function() {
        var audioElement;
        engPlay.onclick = function() {
            play("E")
        };
        espPlay.onclick = function() {
            play("S")
        };
        stopCtr.onclick = function() {
            audioCtr.innerHTML = "";
            playStateMgr.setToPlay();
            audioElement.controls.stop();
            options.onStop()
        };

        function play(languageCode) {
            var audioStr = "";
            playStateMgr.setToLoading();
            options.onPlaybackInitiated();
            audioStr += "<OBJECT id='vpPlayer_" + options.streamKey + "' width='1' height='1' style='position:absolute; left:0;top:0;' classid='CLSID:6BF52A52-394A-11d3-B153-00C04F79FAA6' type='application/x-oleobject'>";
            audioStr += "<PARAM NAME='URL' VALUE='" + buildStreamUrl(languageCode, "asf") + "'>";
            audioStr += "<PARAM NAME='SendPlayStateChangeEvents' VALUE='True'>";
            audioStr += "<PARAM NAME='AutoStart' VALUE='True'>";
            audioStr += "<PARAM name='uiMode' value='none'>";
            audioStr += "<PARAM name='PlayCount' value='1'>";
            audioStr += "</OBJECT>";
            audioCtr.innerHTML = audioStr;
            audioElement = audioCtr.firstChild;
            audioElement.attachEvent("playstatechange", function() {
                switch (audioElement.playState) {
                    case 8:
                        playStateMgr.setToPlay();
                        options.onPlaybackEnded();
                        break;
                    case 3:
                        playStateMgr.setToStop();
                        break;
                    case 6:
                        playStateMgr.setToLoading();
                        break;
                    default:
                        playStateMgr.setToPlay();
                        break
                }
            })
        }
    };
    var attachLINKHandlers = function() {
        engPlay.onclick = function() {
            document.location.href = buildStreamUrl("E", ".wav")
        };
        espPlay.onclick = function() {
            document.location.href = buildStreamUrl("S", ".wav")
        }
    };

    function buildStreamUrl(languageCode, extension) {
        var url = options.streamUrl;
        if (options.additionalInfoOnly) {
            url += "A_"
        }
        url += languageCode + "_" + options.streamKey + extension;
        if (options.streamParams != "") {
            url += "?" + options.streamParams
        }
        return url
    }
    self.playStateMgr = playStateMgr;
    self.options = options;
    buildPlayer();
    vpStreaming.player.instances[elementId] = self
};
vpStreaming.player.instances = {};

export { vpStreaming }